import { useState } from 'react';
import { Button } from 'reactstrap';
import {
  useTranslator,
  Loader,
  useToast,
  cloudflareImage,
  useAppContext,
  mealPlaceholderImage,
  callNativeMobileApp,
} from '@front-activerse/common-components';
import { useNavigate, useOutletContext } from 'react-router-dom';

const DayPlanDayReplacement = ({ dayReplacement, search, replaceDay, date }) => {
  const navigate = useNavigate();
  const { t } = useTranslator();
  const { toastSuccess } = useToast();
  const { trackFirebaseEvent } = useOutletContext();

  const [preload, setPreload] = useState(false);

  const {
    consts: { APP_BRAND },
  } = useAppContext();

  const changeDay = async () => {
    const replacement = {
      replacementId: dayReplacement.dietSetId,
    };

    setPreload(true);

    const response = await replaceDay.replace(replacement);

    if (response.data.me.dietSetReplace.__typename === 'BasicMutationSuccess') {
      setPreload(false);
      callNativeMobileApp({
        action: 'refresh_data',
        payload: {
          module: 'meal_plan',
          date,
        },
      });
      toastSuccess(<p className="mb-0">{t('mealPlan.changeDay.confirmationNotification')}</p>);
      navigate(-1);

      setTimeout(() => {
        document.getElementById('day-plan').scrollIntoView({ behavior: 'smooth' });
      }, 500);
    } else {
      throw new Error(`Replace day failed: ${response.data.me.dietSetReplace.__typename}`);
    }
  };

  const renderMealImage = (preparationImageUrl, mealType) => {
    let mealImg;
    if (preparationImageUrl) {
      mealImg = preparationImageUrl;
    } else {
      mealImg = mealPlaceholderImage(mealType, APP_BRAND);
    }

    const coverImage = cloudflareImage(mealImg, `${APP_BRAND}`, 'mealPlanThumbnail');

    return <img src={coverImage} className="img-fluid" width={80} height={80} alt="" />;
  };

  const mealsOnly = dayReplacement.events.filter((event) => event.__typename === 'Meal');

  return (
    <div className="white-box">
      {mealsOnly.map((event) => (
        <div className="meal-box p-0 no-shadow d-flex align-items-center" key={event.id}>
          <div className="meal-image">
            {renderMealImage(event.preparationImageUrl, event.mealType)}
          </div>
          <div className="meal-content">
            <div className="tags">
              <span className="tag me-1">{event.name}</span>
              {event.mealCustomTag && event.mealCustomTag.label && (
                <span
                  className="tag me-1"
                  style={{ backgroundColor: event.mealCustomTag.color, color: '#fff' }}
                >
                  {event.mealCustomTag.label}
                </span>
              )}
            </div>
            <p className="small semi-bold mb-0">{event.publicName}</p>
          </div>
        </div>
      ))}

      <Button
        color="primary"
        size="sm"
        onClick={async () => {
          changeDay();

          trackFirebaseEvent('user_action', {
            action: 'tap-change_dayplan',
            location: 'Change_dayplan',
          });
        }}
        className="w-100"
        disabled={!dayReplacement.active}
      >
        {t('mealPlan.changeDay.menuCard.chooseButton')}
      </Button>
      {preload ? <Loader /> : ''}
    </div>
  );
};

export default DayPlanDayReplacement;
